import { render, staticRenderFns } from "./PackageConfigurationsLayout.vue?vue&type=template&id=7ecd8956"
import script from "./PackageConfigurationsLayout.vue?vue&type=script&lang=js"
export * from "./PackageConfigurationsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports